<nav class="navbar navbar-expand-lg navbar-light bg-light">
<!--  <div class="button-row">-->
    <button mat-raised-button (click)="location.back()" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> Back
    </button>

    <button
      mat-raised-button
      routerLink="/admin/codes/{{ code.id }}/view"
      *ngIf="code?.id"
      class="m-1 mr-2">
      <mat-icon>visibility</mat-icon>
      View
    </button>

    <button mat-raised-button color="warn" (click)="onDelete(code)" *ngIf="code?.id" class="m-1 mr-2">
      <mat-icon>delete</mat-icon>
      Delete
    </button>
<!--  </div>-->
</nav>

<div class="container-fluid p-3">

  <div class="row">
    <div class="col col-xl-6">

      <div class="card">
        <div class="card-body">
          <h5 class="card-title mb-4">Codes Form</h5>

          <form #form="ngForm" (ngSubmit)="onSubmit()" class="form-container">

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>QR Code Type</mat-label>
              <mat-select [(ngModel)]="code.feature" name="feature" required>
                <mat-option value="Access Control">Site Access Control</mat-option>
                <mat-option value="Asset">Asset</mat-option>
              </mat-select>
            </mat-form-field>

            <mat-form-field class="full-width mb-4" appearance="outline" subscriptSizing="dynamic">
              <mat-label>Name</mat-label>
              <input matInput
                placeholder="Name"
                [(ngModel)]="code.name"
                name="name"
                type="text"
                required
                #name="ngModel"/>
              <mat-error *ngIf="!name.valid">
                Please enter a Codes name.
              </mat-error>
            </mat-form-field>

            <div class="row">
              <div class="col">
                <button
                  class="my-2 ml-0 mr-2"
                  mat-raised-button
                  [disabled]="!form.valid || inProgress"
                  color="primary"
                  type="submit">
                  <mat-icon>save</mat-icon>
                  Save
                </button>
              </div>
            </div>

          </form>

        </div>
      </div>

    </div>
  </div>

</div>
